import Vue from 'vue'
import Vuex from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import main from './modules/main'
import auth from './modules/auth'
import gaps from './modules/gaps'
import notifs from './modules/notifs'
import patients from './modules/patients'
import schedule from './modules/schedule'

Vue.use(Vuex)

export default new Vuex.Store({
  plugins: [createPersistedState({ storage: window.sessionStorage })],
  modules: {
    main, auth, gaps, notifs, patients, schedule
  }
});
